import React, { useEffect, useState } from 'react';
import { setMockTestEditData, submitMockTest } from '../../../../actions/mock-test';
import { useDispatch, useSelector } from 'react-redux';
import KatexViewer from '@/helpers/Katex';

//multiple choice template
const MultipleChoiceTemplate = ({
  question,
  model,
  section,
  scrollToQ,
  answers,
  setAns,
  setAnswer,
}) => {
  const dispatch = useDispatch();

  const [mulans, setMulans] = useState([]);
  const [ids, setId] = useState([]);
  const [checked, setChecked] = useState(false);

  const { multiQuestionLimit, multipleChoice } = useSelector((state: any) => ({
    multiQuestionLimit: state?.MockTestReducer?.multiQuestionLimit,
    multipleChoice: state?.MockTestReducer?.multipleChoice,
  }));
  // useEffect(()=>{
  //     setQcounter(qCounter+1)
  // },[])

  useEffect(() => {
    setChecked(false);
    handleCheckboxObject({ id: '', count: 0, limit: '', ansIds: [] });
    let Arr = [];
    Arr = multipleChoice;
    let tempIndex = multipleChoice.find((each) => each?.id == question.id);
    if (!tempIndex) {
      Arr.push({
        id: question?.id,
        count: 0,
        limit: question?.no_answer,
        ansIds: [],
      });
      dispatch(setMockTestEditData({ key: 'multipleChoice', value: Arr }));
    }

    return () => setChecked(false);
  }, []);

  useEffect(() => {
    for (let i = 0; i < question.no_answer; i++) {
      let q_no = question.q_no + i;
      setAnswer((answers) => {
        return { ...answers, ['q-' + q_no]: mulans };
      });
    }
  }, [mulans]);

  useEffect(() => {
    try {
      var elmnt = document.getElementById('q-' + scrollToQ);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    } catch (err) {
      // console.log('doesnot exist');
    }
    //window.scroll(0,findPos(elmnt));
  }, [scrollToQ]);

  useEffect(() => {
    let obj = answers.find((o) => o.question_id == question.id);
    let idx = answers.findIndex((o) => o.question_id == question.id);
    setAns((prevans) => [
      ...prevans.slice(0, idx),
      { ...prevans[idx], answer_id: ids },
      ...prevans.slice(idx + 1),
    ]);
  }, [ids]);

  const option = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

  const handleSpanClick = (checked, q, ans, id) => {
    const questionData = multipleChoice?.find((each) => each?.id === question?.id);
    dispatch(
      setMockTestEditData({
        key: 'multiQuestionLimit',
        value: {
          id: questionData.id,
          count: questionData?.count,
          limit: questionData?.limit,
          ansIds: questionData?.ansIds,
        },
      })
    );
    if (mulans.includes(ans)) {
      setMulans(mulans.filter((element) => element !== ans));
      setId(ids.filter((element) => element !== id));
    } else {
      setId([...ids, id]);
      setMulans([...ids, id]);
    }
    if (checked) {
      handleCheckClick(id, ans);
    } else {
      handleUncheckClick(id, ans);
    }
  };

  const handleCheckbox = (optionIndex) => {
    let cbId: any = document.getElementById('cb-q-' + question.q_no + optionIndex);
    const check = cbId && cbId?.checked;
    cbId.checked = !check;
  };

  const handleSubmit = (id, answerType) => {
    dispatch(
      submitMockTest(
        JSON.stringify({
          model: model,
          section: section,
          answer: id,
          question: question.id,
          is_correct: 'true',
          answer_type: answerType,
        })
      )
    );
  };
  const handleCheckboxObject = (value) => {
    dispatch(
      setMockTestEditData({
        key: 'multiQuestionLimit',
        value: { id: question?.id, limit: question?.no_answer, ...value },
      })
    );
  };

  const handleCheckboxArray = (value) => {
    dispatch(setMockTestEditData({ key: 'multipleChoice', value: value }));
  };

  const handleCheckClick = (id, optionIndex) => {
    if (multiQuestionLimit?.count < question?.no_answer) {
      setChecked(true);
      handleCheckbox(optionIndex);

      let qData = {
        count:
          multiQuestionLimit?.id == question.id ? multiQuestionLimit?.count + 1 : 1,
        ansIds:
          multiQuestionLimit?.id == question.id
            ? [...multiQuestionLimit.ansIds, id]
            : [id],
      };
      handleCheckboxObject(qData);

      let Arr = [];
      if (multipleChoice?.length == 0) {
        Arr.push(qData);
      } else {
        Arr = multipleChoice;
        let tempIndex = multipleChoice.findIndex((each) => each?.id == question.id);
        let ans = [...Arr[tempIndex]?.ansIds, id];
        Arr[tempIndex] = {
          ...Arr[tempIndex],
          count: Arr[tempIndex]?.count + 1,
          // ansIds: [...Arr[tempIndex]?.ansIds, id],
          ansIds: ans.filter((item, index) => ans.indexOf(item) === index),
        };
      }
      dispatch(setMockTestEditData({ key: 'multipleChoice', value: Arr }));
      handleSubmit(id, 'add');
    }
    // else {
    //   notification.error({
    //     message: `Select only ${multiQuestionLimit?.limit} answers`,
    //   });
    // }
  };

  const handleUncheckClick = (id, optionIndex) => {
    setChecked(false);
    handleCheckbox(optionIndex);
    handleSubmit(id, 'remove');
    let qData = {
      count:
        multiQuestionLimit?.id == question.id
          ? multiQuestionLimit?.count == 0
            ? 0
            : multiQuestionLimit?.count - 1
          : 0,
      ansIds: multiQuestionLimit.ansIds.filter((each: any) => each !== id),
    };
    handleCheckboxObject(qData);

    let Arr = [];
    Arr = multipleChoice;
    let tempIndex = multipleChoice.findIndex((each) => each?.id == question.id);
    let ans = [...Arr[tempIndex]?.ansIds, id];
    Arr[tempIndex] = {
      ...Arr[tempIndex],
      count: Arr[tempIndex]?.count === 0 ? 0 : Arr[tempIndex]?.count - 1,
      // ansIds: [...Arr[tempIndex]?.ansIds, id],
      ansIds: Arr[tempIndex]?.ansIds?.filter((each: any) => each !== id),
    };
    dispatch(setMockTestEditData({ key: 'multipleChoice', value: Arr }));
  };

  const qnumber =
    question?.no_answer > 1
      ? `${question.q_no}-${question?.q_no + question?.no_answer - 1}`
      : question?.q_no;

  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          {question?.no_answer > 1 ? (
            <div className="number-text px-2" id={`q-${question.q_no}`}>
              Questions {qnumber}
            </div>
          ) : (
            <div className="number" id={`q-${question.q_no}`}>
              {qnumber}
            </div>
          )}
        </div>
      </div>
      <div className="type_blank">
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <ul className="list-question">
          {question.answer.map((a, i) => (
            <li
              key={i}
              className="cursor-pointer"
              onClick={() => {
                let cbId: any = document.getElementById(
                  'cb-q-' + question.q_no + option[i]
                );
                const check = cbId && cbId?.checked;
                handleSpanClick(!check, 'q-' + question.q_no, option[i], a.id);
                // cbId.checked = !check;
              }}
            >
              <span>
                <span className="lq-number">{option[i]}</span>
                <span className="my-radio">
                  <input
                    id={'cb-q-' + question.q_no + option[i]}
                    className="my-auto"
                    type="checkbox"
                    name="q-1"
                    value={option[i]}
                    onClick={() => {
                      let cbId: any = document.getElementById(
                        'cb-q-' + question.q_no + option[i]
                      );
                      const check = cbId && cbId?.checked;
                      handleSpanClick(!check, 'q-' + question.q_no, option[i], a.id);
                      // cbId.checked = !check;
                    }}
                    //  onChange={(e) => {
                    //    onAnswered(e, 'q-' + question.q_no, option[i], a.id);
                    //  }}
                    //  checked={
                    //    // checked &&
                    //    // multiQuestionLimit?.count <= multiQuestionLimit?.limit &&
                    //    // multiQuestionLimit?.ansIds?.includes(a?.id)
                    //    multipleChoice
                    //      ?.find((each) => each?.id == question?.id)
                    //      ?.ansIds?.includes(a?.id)
                    //  }
                  />
                  <label>
                    {question?.has_expression ? (
                      <KatexViewer text={a?.text} />
                    ) : (
                      a.text
                    )}
                  </label>
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MultipleChoiceTemplate;
